import RevealOnScroll from '../base/RevealOnScroll';
import { testimonials } from '../../mocks/testimonials';

export default function TestimonialsSection() {
  const featured = testimonials[4]; // Ericka Gutierrez — most detailed
  const rest = testimonials.filter((_, i) => i !== 4);

  return (
    <section className="bg-[#0F0F0F] py-28 lg:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Header */}
        <RevealOnScroll className="mb-16">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-px bg-[#BF9448]" />
                <span className="text-[#BF9448] text-[10px] font-sans font-semibold tracking-[0.25em] uppercase">
                  Client Reviews
                </span>
              </div>
              <h2
                className="font-serif font-semibold text-white leading-tight"
                style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)' }}
              >
                What Houston Homeowners Say
              </h2>
            </div>
            <div className="flex items-center gap-3 lg:pb-1">
              <div className="flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((s) => (
                  <span key={s} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-[#BF9448] text-base"></i>
                  </span>
                ))}
              </div>
              <span className="font-sans text-white/40 text-sm">5.0 · Google Verified Reviews</span>
            </div>
          </div>
        </RevealOnScroll>

        {/* Featured testimonial */}
        <RevealOnScroll className="mb-6">
          <div className="relative bg-[#1A1815] border border-white/8 p-8 lg:p-12 overflow-hidden">
            {/* Decorative large quote */}
            <div className="absolute top-6 right-8 font-serif text-[#BF9448]/8 text-[10rem] leading-none select-none pointer-events-none font-bold">
              &ldquo;
            </div>
            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
              <div className="lg:col-span-2">
                <p className="font-serif text-white/85 text-xl lg:text-2xl leading-relaxed font-light italic mb-8">
                  &ldquo;{featured.text}&rdquo;
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 border border-[#BF9448]/30">
                    <img src={featured.avatar} alt={featured.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="font-sans text-white font-semibold text-sm">{featured.name}</div>
                    <div className="flex items-center gap-2 mt-0.5">
                      <div className="flex items-center gap-0.5">
                        {[1, 2, 3, 4, 5].map((s) => (
                          <span key={s} className="w-3 h-3 flex items-center justify-center">
                            <i className="ri-star-fill text-[#BF9448] text-xs"></i>
                          </span>
                        ))}
                      </div>
                      <span className="font-sans text-white/35 text-xs">{featured.source} Review</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Featured stats */}
              <div className="flex flex-row lg:flex-col gap-5 lg:justify-center lg:items-start lg:border-l lg:border-white/10 lg:pl-8">
                {[
                  { v: '16+', l: 'Years in Houston' },
                  { v: '5.0★', l: 'Avg. Rating' },
                  { v: '60%+', l: 'Repeat Clients' },
                ].map((s, i) => (
                  <div key={i}>
                    <div className="font-serif text-[#BF9448] font-semibold text-2xl leading-none">{s.v}</div>
                    <div className="font-sans text-white/35 text-[10px] uppercase tracking-widest mt-1">{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </RevealOnScroll>

        {/* Remaining testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {rest.map((t, i) => (
            <RevealOnScroll key={t.id} delayMs={i * 50}>
              <article className="group bg-[#0F0F0F] hover:bg-[#141210] transition-colors duration-300 p-6 lg:p-7">
                {/* Stars */}
                <div className="flex items-center gap-0.5 mb-4">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <span key={s} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-[#BF9448] text-xs"></i>
                    </span>
                  ))}
                </div>
                {/* Quote */}
                <p className="font-sans text-white/55 text-sm leading-relaxed mb-6 line-clamp-4">
                  &ldquo;{t.text}&rdquo;
                </p>
                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-white/6">
                  <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 border border-white/10">
                    <img src={t.avatar} alt={`${t.name} Google review`} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="font-sans text-white text-xs font-semibold">{t.name}</div>
                    <div className="font-sans text-white/30 text-[10px]">{t.source}</div>
                  </div>
                </div>
              </article>
            </RevealOnScroll>
          ))}
        </div>

        <RevealOnScroll className="mt-12 text-center">
          <a
            href="#quote"
            className="inline-flex items-center gap-3 border border-white/15 hover:border-[#BF9448]/50 text-white font-sans text-xs font-semibold px-8 py-4 rounded-sm transition-all duration-200 whitespace-nowrap cursor-pointer tracking-[0.12em] uppercase"
          >
            Join Our 5-Star Client Base
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </RevealOnScroll>

      </div>
    </section>
  );
}
